import React from 'react'

const NotFound: React.FC = () => {
    return (
        <>
            <h1>Desculpe!</h1>
            <p>Página não encontrada</p>
        </>
        )
}

export default NotFound